export default __webpack_public_path__ + "8caed91c9a7d904c76bad5d6ee498189.svg";